<template>
    <v-input class="v-text-field v-numeric-field" >

        <!-- <v-text-field @keypress="KeyPressed" @input="UpdateValue" @blur="FixInputValue" :maxLength="maxLength == 0 ? undefined : maxLength"></v-text-field> -->
        
        <div :tabIndex="0" @focus="input.focus" v-bind:class="{ 'v-field--appended': appendInnerIcon != '' || appendText != '', 'v-field--focused': focused, 'v-field--disabled': disabled }" class="v-field v-field--variant-outlined" role="textbox">
            <div class="v-field__overlay"></div>
            
            <div class="v-field__field" data-no-activator="">
                
                <label class="v-label v-field-label"></label>
                
                <div class="v-field__input" data-no-activator="">
                    <input 
                        v-bind="$attrs" 
                        ref="input" 
                        @focus="focused = true"
                        @blur="focused = false"
                        @paste="FixPasteValue()"
                        @keypress="KeyPressed" @input="UpdateValue" @change="FixInputValue"
                        type="text" size="1" :maxLength="maxLength == 0 ? undefined : maxLength"
                        :maxValue="maxValue"
                        :autofocus="autofocus">
                </div>
                
            </div>
            
            <div v-if="appendInnerIcon != ''" class="v-field__append-inner">
                <i v-bind:class="appendInnerIcon" class="mdi v-icon notranslate v-icon--size-default" aria-hidden="true"></i>
            </div>
            <div v-if="appendText != ''" class="v-field__append-inner">
                {{ appendText }}
            </div>
            
            <div class="v-field__outline">
                <div class="v-field__outline__start"></div>
                <div class="v-field__outline__end"></div>
            </div>
            
        </div>

    </v-input>
</template>
<script lang="ts">
import { computed, defineComponent, onMounted, PropType, Ref, ref, watch } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
    props: {
        modelValue: {
            type: null as unknown as PropType<number | null>,
            required: false
        },
        numberOfDecimals: {
            type: Number,
            default: 0
        },
        maxLength: {
            type: Number,
            default: 0
        },
        appendInnerIcon: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        maxValue: {
            type: Number
        },
        autofocus: {
            type: Boolean,
            default: false
        },
        formatNumber: {
            type: Function as PropType<(value: number, decimals: number) => string>,
            required: false
        },
        appendText: {
            type: String,
            default: ''
        }
    },
    setup(props, { emit }) {
        const input: any = ref(null);
        const focused: Ref<boolean> = ref(false);
        const modelValueReactive = computed(() => props.modelValue);
        const { n } = useI18n();

        // async function FixPasteValue() {
        //     await navigator.clipboard.readText().then((text: string) => {
        //         text = text.replace(/\D/g, '');
        //         let textNum: number = parseFloat(text.replace(',', '.'));
        //         SetValue(isNaN(textNum) ? 0 : textNum);
        //     });
        // }

        async function FixPasteValue() {
            await navigator.clipboard.readText().then((text: string) => {
                text = text.replace(/\s/g, '').replace(/(?<=\d)\.(?=\d{3})/g, '').replace(',', '.');

                let textNum: number = parseFloat(text);
                SetValue(isNaN(textNum) ? 0 : textNum);
            });
        };

        watch(modelValueReactive, () => {
            if (props.maxValue && props.modelValue! > props.maxValue) {
                SetValue(props.maxValue);
            } else {
                SetValue(modelValueReactive.value);
            }
        });

        onMounted(() => {
            SetValue(props.modelValue);
        });

        function SetValue(newValue: number | null | undefined) {
            if (newValue != parseFloat(input.value.value.replace(',', '.'))) {
                if (newValue != null) {
                    input.value.value = n(parseFloat(newValue.toString().replace(',', '.')), { key: 'decimal', minimumFractionDigits: props.numberOfDecimals, maximumFractionDigits: props.numberOfDecimals, useGrouping: false });
                }
            }
        };

        function KeyPressed(event: any) {
            if (props.maxLength == 1 && !isNaN(parseInt(event.key))) {
                event.target.value = '';
            } else if (props.numberOfDecimals == 0 && event.key == ',') {
                event.preventDefault();
            } else if (event.key != ',' && isNaN(parseInt(event.key))) {
                event.preventDefault();
            }
        };

        function UpdateValue(event: any) {
            let value: number = parseFloat(event.target.value.replace(',', '.'));
            emit("update:modelValue", !isNaN(value) ? value : null);
        };

        function FixInputValue(event: any) {
            focused.value = false;
            let value: string = event.target.value;

            if (value && props.numberOfDecimals > 0) {
                event.target.value = n(parseFloat(value.replace(',', '.')), { key: 'decimal', minimumFractionDigits: props.numberOfDecimals, maximumFractionDigits: props.numberOfDecimals, useGrouping: false });
                emit("update:modelValue", parseFloat(event.target.value.replace(',', '.')));
            }
        };

        return {
            input,
            focused,
            KeyPressed,
            UpdateValue,
            FixInputValue,
            FixPasteValue
        };
    }
});
</script>
